/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ExceptionInfo'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ExceptionInfo'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.LoggerMessage = factory(root.GisServerApis.ApiClient, root.GisServerApis.ExceptionInfo);
  }
}(this, function(ApiClient, ExceptionInfo) {
  'use strict';




  /**
   * The LoggerMessage model module.
   * @module model/LoggerMessage
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>LoggerMessage</code>.
   * @alias module:model/LoggerMessage
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>LoggerMessage</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LoggerMessage} obj Optional instance to populate.
   * @return {module:model/LoggerMessage} The populated <code>LoggerMessage</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('customData')) {
        obj['customData'] = ApiClient.convertToType(data['customData'], {'String': 'String'});
      }
      if (data.hasOwnProperty('dateTime')) {
        obj['dateTime'] = ApiClient.convertToType(data['dateTime'], 'Date');
      }
      if (data.hasOwnProperty('loggerLevel')) {
        obj['loggerLevel'] = ApiClient.convertToType(data['loggerLevel'], 'String');
      }
      if (data.hasOwnProperty('error')) {
        obj['error'] = ExceptionInfo.constructFromObject(data['error']);
      }
      if (data.hasOwnProperty('message')) {
        obj['message'] = ApiClient.convertToType(data['message'], 'String');
      }
      if (data.hasOwnProperty('category')) {
        obj['category'] = ApiClient.convertToType(data['category'], 'String');
      }
      if (data.hasOwnProperty('elapsed')) {
        obj['elapsed'] = ApiClient.convertToType(data['elapsed'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {Object.<String, String>} customData
   */
  exports.prototype['customData'] = undefined;
  /**
   * @member {Date} dateTime
   */
  exports.prototype['dateTime'] = undefined;
  /**
   * @member {module:model/LoggerMessage.LoggerLevelEnum} loggerLevel
   */
  exports.prototype['loggerLevel'] = undefined;
  /**
   * @member {module:model/ExceptionInfo} error
   */
  exports.prototype['error'] = undefined;
  /**
   * @member {String} message
   */
  exports.prototype['message'] = undefined;
  /**
   * @member {String} category
   */
  exports.prototype['category'] = undefined;
  /**
   * @member {String} elapsed
   */
  exports.prototype['elapsed'] = undefined;


  /**
   * Allowed values for the <code>loggerLevel</code> property.
   * @enum {String}
   * @readonly
   */
  exports.LoggerLevelEnum = {
    /**
     * value: "Information"
     * @const
     */
    "Information": "Information",
    /**
     * value: "Usage"
     * @const
     */
    "Usage": "Usage",
    /**
     * value: "Debug"
     * @const
     */
    "Debug": "Debug",
    /**
     * value: "Warning"
     * @const
     */
    "Warning": "Warning",
    /**
     * value: "Error"
     * @const
     */
    "Error": "Error"  };


  return exports;
}));



